class Database {
  fetchUser = async () => {
    try {
      const res = await fetch("/wp-admin/admin-ajax.php", {
        method: "POST",
        credentials: "same-origin",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded"
        }),
        body: "action=fetch_user"
      });
      return await res.json();
    } catch (err) {
      return console.log(err);
    }
  };

  ajaxCall = async params => {
    try {
      const res = await fetch("/wp-admin/admin-ajax.php", {
        method: "POST",
        credentials: "same-origin",
        // headers: new Headers({
        //   "Content-Type": "application/x-www-form-urlencoded"
        // }),
        body: new URLSearchParams(params)
      });
      let response = await res.json();
      return response;
    } catch (err) {
      return err;
    }
  };
}

export default Database;
